export class UnitFormatter {
  // -------------------------------------------------------------------------
  public static memorySize(bytes: number, decimals: number = 2): string {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k: number = 1024;
    const dm: number = decimals < 0 ? 0 : decimals;
    const sizes: string[] = ['Bytes', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i: number = Math.floor(Math.log(bytes) / Math.log(k));

    return (i < sizes.length)
      ? `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
      : `${bytes / Math.pow(k, (sizes.length - 1))} ${sizes[sizes.length - 1]}`;
  }
  // -------------------------------------------------------------------------
  public static secondsToTime(seconds: number): string {
    return [
      UnitFormatter.number2Digits(Math.floor(seconds / 3600)),
      UnitFormatter.number2Digits(Math.floor(seconds / 60) % 60),
      UnitFormatter.number2Digits(seconds % 60),
    ].join(':');
  }
  // -------------------------------------------------------------------------
  public static number2Digits(value: number): string  {
    const valueNumber: number = Math.floor(value);

    return (valueNumber < 10) ? `0${valueNumber}` : String(valueNumber);
  }
  // -------------------------------------------------------------------------
}
